<template>
	<div>
		<h2 class="mt-3">Linguagem</h2>
		<form @submit.prevent="submit">
			<div class="row">
				<form-select
					v-model="caractSaude.pronuncia_correta"
					:itens="$root.arrays.pergunta"
					label="Pronuncia corretamente as palavras?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.troca_letra"
					:itens="$root.arrays.pergunta"
					label="Troca letras?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.omite_letras"
					:itens="$root.arrays.pergunta"
					label="Omite letras?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.gagueira"
					:itens="$root.arrays.pergunta"
					label="Apresenta gagueiras?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.compreende_perguntas"
					:itens="$root.arrays.pergunta"
					label="Compreende perguntas que lhe são feitas?"
					:required="true"
					grid="6"
				/>
			</div>
			<h2 class="mt-3">Alimentação</h2>
			<div class="row">
				<form-select
					v-model="caractSaude.apetite"
					:itens="$root.arrays.pergunta"
					label="Tem bom apetite?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.alergia_alimento"
					:itens="$root.arrays.pergunta"
					label="Tem alergia a algum alimento?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.recusa_alimentar"
					:itens="$root.arrays.pergunta"
					label="Recusa alimentação?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.ajuda_alimentar"
					:itens="$root.arrays.pergunta"
					label="Necessita de ajuda para se alimentar?"
					:required="true"
					grid="6"
				/>
			</div>
			<h2 class="mt-3">Saúde</h2>
			<div class="row">
				<form-select
					v-model="caractSaude.cartao_vacina"
					:itens="$root.arrays.pergunta"
					label="Possui cartão de vacina?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.cartao_atualizado"
					:itens="$root.arrays.pergunta"
					label="O cartão está atualizado?"
					:required="true"
					grid="6"
				/>

				<form-select
					v-model="caractSaude.estabanada"
					:itens="$root.arrays.pergunta"
					label="É desastrada/desatenciosa (esbarra nos móveis, derruba água ou comida na mesa)?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.problema_ortopedico"
					:itens="$root.arrays.pergunta"
					label="Apresenta algum problema ortopédico (pé chato, torto etc.)?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.aproxima_objetos"
					:itens="$root.arrays.pergunta"
					label="Aproxima muito os objetos para vê-los?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.aperta_olhos"
					:itens="$root.arrays.pergunta"
					label="Aperta os olhos para olhar à distância?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.inflamacao_ouvidos"
					:itens="$root.arrays.pergunta"
					label="Costuma ter inflamações nos ouvidos?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.reacao_ruidos"
					:itens="$root.arrays.pergunta"
					label="Apresenta reações diferentes a ruídos diferentes?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.reacao_cheiros"
					:itens="$root.arrays.pergunta"
					label="Apresenta alguma reação especial a diferentes tipos de cheiro e gosto?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.tomou_vacinas"
					:itens="$root.arrays.pergunta"
					label="Tomou as vacinas necessárias conforme a idade?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.doencas_infantis"
					:itens="$root.arrays.acolhimento_doencas_infantis"
					label="Que doenças infantis já teve?"
					:multiple="true"
					grid="6"
				/>
				<form-input
					v-if="caractSaude.doencas_infantis == 5"
					v-model="caractSaude.doencas_outras"
					label="Quais outras doenças?"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.uso_prolongado_medicamento"
					:itens="$root.arrays.pergunta"
					label="Faz uso constante ou prolongado de medicamentos?"
					:required="true"
					grid="6"
				/>
				<form-input
					v-if="caractSaude.uso_prolongado_medicamento == 1"
					v-model="caractSaude.uso_medicamento_quais"
					label="Quais?"
					:required="true"
					grid="6"
				/>
				<form-input
					v-if="caractSaude.uso_prolongado_medicamento == 1"
					v-model="caractSaude.uso_medicamento_periodo"
					label="Qual periodo?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.alergia"
					:itens="$root.arrays.pergunta"
					label="Tem alergias?"
					:required="true"
					grid="6"
				/>

				<form-input
					v-if="caractSaude.alergia == 1"
					v-model="caractSaude.alergia_a_que"
					label="A que?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.sofreu_acidente"
					:itens="$root.arrays.pergunta"
					label="Já sofreu algum acidente ou queda?"
					:required="true"
					grid="6"
				/>

				<form-input
					v-if="caractSaude.sofreu_acidente == 1"
					v-model="caractSaude.como_reagiu_acidente"
					label="Como reagiu? "
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.cuidado_especial"
					:itens="$root.arrays.pergunta"
					label="Precisa de algum cuidado especial por motivo de saúde?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.ind_acompanhamento_psicologico"
					:itens="$root.arrays.pergunta"
					label="Há indicação para acompanhamento psicológico?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.ja_acompanhamento_psicologico"
					:itens="$root.arrays.pergunta"
					label="Já passou por acompanhamento psicológico?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.encaminhar_atendimento_medico"
					:itens="$root.arrays.pergunta"
					label="É necessário encaminhamento para Atendimento médico especializado?"
					:required="true"
					grid="6"
				/>

				<form-input
					v-if="caractSaude.encaminhar_atendimento_medico == 1"
					v-model="caractSaude.atendimento_medico_quais"
					label="Quais?"
					:required="true"
					grid="6"
				/>
			</div>
			<h2 class="mt-3">Sexualidade</h2>
			<div class="row">
				<form-select
					v-model="caractSaude.sexualidade_compativel_idade"
					:itens="$root.arrays.pergunta"
					label="Sua sexualidade é compatível com a idade?"
					:required="true"
					grid="6"
				/>

				<form-input
					v-if="caractSaude.sexualidade_compativel_idade == 1"
					v-model="caractSaude.sexualidade_compativel_porque"
					label="Por que?"
					:required="true"
					grid="6"
				/>
			</div>
			<h2 class="mt-3">
				Tiques (atos involuntários) e Manipulações (atos voluntários)
			</h2>
			<div class="row">
				<form-select
					v-model="caractSaude.chupeta"
					:itens="$root.arrays.pergunta"
					label="Usa chupeta?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.roi_unha"
					:itens="$root.arrays.pergunta"
					label="Rói unhas?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.chupa_dedo"
					:itens="$root.arrays.pergunta"
					label="Chupa dedo?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.apresenta_tique"
					:itens="$root.arrays.pergunta"
					label="Apresenta algum tique?"
					:required="true"
					grid="6"
				/>
				<form-textarea
					v-if="caractSaude.apresenta_tique == 1"
					v-model="caractSaude.tique_descricao"
					label="Descreva:"
					:required="true"
				/>
			</div>
			<h2 class="mt-3">Emoções/Comportamentos</h2>
			<div class="row">
				<form-select
					v-model="caractSaude.medo"
					:itens="$root.arrays.pergunta"
					label="Demonstrou medo?"
					:required="true"
					grid="6"
				/>
				<form-input
					v-if="caractSaude.medo == 1"
					v-model="caractSaude.medo_de_que"
					label="Quais? "
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.irrita_facil"
					:itens="$root.arrays.pergunta"
					label="Irrita-se facilmente?"
					:required="true"
					grid="6"
				/>
				<form-textarea
					v-if="caractSaude.irrita_facil == 1"
					v-model="caractSaude.reage_frustacao"
					label="Como reage quando frustrado? "
					:required="true"
				/>
				<form-input
					v
					v-model="caractSaude.expressa_emocoes"
					label="Como expressa suas emoções? (é espontâneo nos afetos, tolhido, foge dos contatos):"
					:required="true"
					grid="6"
				/>
				<form-input
					v-model="caractSaude.reage_raiva"
					label="Como reage quando tem raiva? (isola - se, torna-se agressivo): "
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.chora_frequente"
					:itens="$root.arrays.pergunta"
					label="Chora frequentemente?"
					:required="true"
					grid="6"
				/>
			</div>
			<h2 class="mt-3">Disciplina</h2>
			<div class="row">
				<form-select
					v-model="caractSaude.necessita_disciplina"
					:itens="$root.arrays.pergunta"
					label="Necessita ser disciplinado?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.aceita_disciplina"
					:itens="$root.arrays.pergunta"
					label="Aceita ser disciplinado?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.respeita_autoridade"
					:itens="$root.arrays.pergunta"
					label="Respeita a figura da autoridade?"
					:required="true"
					grid="6"
				/>
			</div>
			<h2 class="mt-3">Relacionamento com pais/amigos/em sociedade</h2>
			<div class="row">
				<form-select
					v-model="caractSaude.aproximacao_pai"
					:itens="$root.arrays.pergunta"
					label="Tem boa aproximação com o pai?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.aproximacao_mae"
					:itens="$root.arrays.pergunta"
					label="Tem boa aproximação com a mãe?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.preferencia_genitores"
					:itens="$root.arrays.pergunta"
					label="Mostra preferência por um dos genitores?"
					:required="true"
					grid="6"
				/>
				<form-textarea
					v-if="caractSaude.preferencia_genitores == 1"
					v-model="caractSaude.preferencia_genitores_motivo"
					label="Por qual motivo?"
					:required="true"
				/>
				<form-textarea
					v-model="caractSaude.bem_entre_irmaos"
					:itens="$root.arrays.pergunta"
					label="Sente-se bem entre os irmãos?"
					:required="true"
				/>
				<form-select
					v-model="caractSaude.relacao_boa_acolidos"
					:itens="$root.arrays.pergunta"
					label="Relaciona-se bem com os outros acolhidos?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.relacao_boa_funcionarios"
					:itens="$root.arrays.pergunta"
					label="Relaciona-se bem com os funcionários?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.brinca"
					:itens="$root.arrays.pergunta"
					label="Gosta de brincar?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="caractSaude.brinca_com_pessoas"
					:itens="$root.arrays.acolhimento_brinca_com_pessoas"
					label="Brinca com pessoas?"
					:required="true"
					grid="6"
				/>
				<!-- <form-select
          v-model="caractSaude.nao_brinca"
          :itens="$root.arrays.pergunta"
          label="Não brinca, só observa?"
          :required="true"
          grid="6"
        /> -->
			</div>
			<div class="row pt-4 px-0 d-flex justify-content-end">
				<div class="col-auto px-2 text-right">
					<button class="btn btn-success btn-submit" type="submit">
						<i class="mdi mdi-content-save" />
						{{ $t("Salvar") }}
					</button>
				</div>
			</div>
		</form>
	</div>
</template>
<script>
export default {
	props: ["item"],
	data() {
		return { caractSaude: {} };
	},
	mounted() {
		if (this.item.caractSaude != null) {
			this.caractSaude = this.item.caractSaude;
		}
	},
	methods: {
		submit() {
			this.item.caractSaude = this.caractSaude;
			this.$emit("submit");
		},
	},
};
</script>
